module.exports = __webpack_public_path__ + "img/gb.d3ddd602.svg";